import React from 'react'

const AdminHome = () => {
  return (
    <div>
      admin home
    </div>
  )
}

export default AdminHome
